<template>
  <v-container
    id="register"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="9"
      >
        <v-slide-y-transition appear>
          <v-card
            class="pa-3 pa-md-5 mx-auto"
            light
          >
            <pages-heading class="text-center display-3">
              Help
            </pages-heading>

            <v-row justify="center">
              <v-col
                cols="12"
                md="9"
              >
                <v-row no-gutters>
                  <v-col
                    cols="12"
                  >
                    <v-list-item three-line>
                      <v-list-item-icon class="mr-4 mt-5 mt-md-4">
                        <v-icon
                          :large="$vuetify.breakpoint.mdAndUp"
                          color="success"
                        >
                          mdi-help
                        </v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title
                          class="font-weight-light mb-4 mt-3"
                        >
                          F.A.Q.
                        </v-list-item-title>

                        <v-expansion-panels popout>
                          <v-expansion-panel
                            v-for="(item, i) in faqs"
                            :key="i"
                          >
                            <v-expansion-panel-header>
                              {{ item.q }}
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                              <div
                                v-for="(answer, j) in item.a"
                                :key="j"
                                class="pb-4"
                              >
                                <v-img
                                  v-if="answer.type === 'img'"
                                  :src="require(`@/assets/${answer.content}`)"
                                  max-width="80%"
                                />
                                <h2 v-if="answer.type === 'h'">
                                  {{ answer.content }}
                                </h2>
                                <p v-if="answer.type === 'p'">
                                  {{ answer.content }}
                                </p>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Help',

    components: {
      PagesHeading: () => import('./components/Heading'),
    },

    data: () => ({
      faqs: [
        {
          q: 'How do I sign up/create an account?',
          a: [
            {
              type: 'h',
              content: 'Who can create an account?',
            },
            {
              type: 'p',
              content: 'If your company has signed up to use PDF Brander then you will be able to create an account using your work email address and start using PDF Brander right away.',
            },
            {
              type: 'p',
              content: 'If your company has signed up and is ready to use PDF Brander then follow the following steps to sign up for your own account:',
            },
            {
              type: 'h',
              content: 'Creating an account:',
            },
            {
              type: 'p',
              content: '1. Go to the main page, which will send you to the login page',
            },
            {
              type: 'p',
              content: '2. Click on create account',
            },
            {
              type: 'img',
              content: 'pdf-brander-create-account.png',
            },
            {
              type: 'p',
              content: '3. Enter your work email account and create a new password with a minimum length of 8 characters',
            },
            {
              type: 'img',
              content: 'pdf-brander-2.png',
            },
            {
              type: 'p',
              content: '4. You will be emailed a code to your email address, enter the code here',
            },
            {
              type: 'img',
              content: 'pdf-brander-3.png',
            },
            {
              type: 'p',
              content: '5. You can now use the PDF Brander tool',
            },
            {
              type: 'img',
              content: 'pdf-brander-4.png',
            },

          ],
        },
        {
          q: 'I can\'t create an account',
          a: [
            {
              type: 'h',
              content: 'PreSignUp failed',
            },
            {
              type: 'p',
              content: 'If you are seeing the error "PreSignUp failed with error Email support@mcalpinefree.co.nz to get an account" it means the email you are trying to sign up with is not associated with a company that has registered to use PDF Brander.',
            },
            {
              type: 'p',
              content: 'Make sure that you are using your work email address. If you are using the correct email address and are still recieving this error please contact support@mcalpinefree.co.nz',
            },
          ],
        },
        {
          q: 'How do you upload multiple files at once?',
          a: [
            {
              type: 'h',
              content: 'Click in the PDF input area to start selecting PDFs',
            },
            {
              type: 'img',
              content: 'click_select_pdf.png',
            },
            {
              type: 'h',
              content: 'In the window that opens up select multiple files.',
            },
            {
              type: 'p',
              content: 'You can either select one file, then while holding down the Shift key select another file, all files inbetween the two selected files will now be selected or select one file, then holding down the Control key (Command key on Mac) select another file, both files will now be selected, but not the files in between',
            },
            {
              type: 'img',
              content: 'multiple_pdfs_windows.png',
            },
            {
              type: 'p',
              content: 'Once you have selected the PDFs you would like to upload, click "Open"',
            },
          ],
        },
        {
          q: 'Total file size too large',
          a: [
            {
              type: 'h',
              content: 'If you see this message the files you are trying to upload are too large',
            },
            {
              type: 'img',
              content: 'large_files_error.png',
            },
            {
              type: 'p',
              content: 'The current total supported files size at a time is 20 MB, if you are uploading multiple files at a time try selecting them individually. If you are trying to upload a single file that is larger than 20MB, please contact support@mcalpinefree.co.nz',
            },
          ],
        },
      ],
    }),
  }
</script>

<style scoped lang="sass">
  #register
    .v-list-item__subtitle
      -webkic-line-clamp: initial
      -webkit-box-orient: initial
  p
    line-height: 1.6em
</style>
